<app-anonymous-page-layout>
  <app-card *ngIf="!isValidLoginLink">
    <app-page-title
      [title]="'PAGE.EMAIL_LINK_LOGIN.TITLE' | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>
    {{ 'PAGE.EMAIL_LINK_LOGIN.INVALID_LINK' | translate }}
  </app-card>
  <!-- Only need to render form if we don't know the email -->
  <app-card *ngIf="isValidLoginLink && !isEmailKnown">
    <app-page-title
      [title]="'PAGE.EMAIL_LINK_LOGIN.TITLE' | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>
    <form class="form-layout" (submit)="submitForm()" [formGroup]="form">
      <app-form-element
        class="item"
        [label]="'LABEL.EMAIL' | translate"
        inputId="email"
        [errors]="formHelper.getErrors('email')"
        [description]="'PAGE.EMAIL_LINK_LOGIN.LABEL.EMAIL_DESCRIPTION' | translate"
      >
        <mat-form-field>
          <input matInput id="email" type="email" required [formControl]="form.controls.email" />
        </mat-form-field>
      </app-form-element>
      <div class="actions">
        <app-button [label]="'PAGE.EMAIL_LINK_LOGIN.ACTION.LOGIN' | translate"></app-button>
      </div>
    </form>
  </app-card>
</app-anonymous-page-layout>
